import {
  Directive,
  OnChanges,
  SimpleChanges,
  inject,
  input,
  contentChildren,
  effect,
  computed,
} from '@angular/core';
import { MatTabLink, MatTabNav } from '@angular/material/tabs';

@Directive({
  selector: '[muloVerticalTabs]',
  host: { class: 'has-vertical-ink-bar is-vertical' },
  standalone: true,
})
export class VerticalTabsDirective implements OnChanges {
  private host = inject(MatTabNav);

  readonly muloVerticalTabs = input(undefined);
  readonly contentTabs = contentChildren(MatTabLink, { descendants: true });
  readonly activeTab = computed(() =>
    this.contentTabs().find((child) => child.active),
  );

  /* the inkbar  element */
  inkbar;
  /* the margin of the tabs (done by css externally) */
  margin;
  /* adding a few pixels to the bar for aesthtics and usability */
  tweak = 3;

  offsetSet = false;

  constructor() {
    const host = this.host;

    host.disablePagination = true;

    effect(() => {
      const tabs = this.contentTabs();
      if (
        !this.activeTab() &&
        tabs.length > 0 &&
        tabs[0].elementRef?.nativeElement
      ) {
        /* if no active tab, at least it should be accessible */
        tabs[0].elementRef.nativeElement.tabIndex = 0;
      }
    });
  }
  /* We're listening to input changes (typically the 'selectedIndex') */
  ngOnChanges(changes: SimpleChanges) {
    const tabChange = changes['muloVerticalTabs'];

    if (!this.offsetSet && tabChange.firstChange) {
      setTimeout(() => {
        this.getTabOffset(tabChange.currentValue);
      }, 0);
    } else {
      this.getTabOffset(tabChange.currentValue);
    }
  }

  setInkbarOffset(tabs) {
    /* Early exit if no tabs */
    if (!tabs || !tabs.first) return null;

    const el = tabs.first.elementRef.nativeElement; //elementRef.nativeElement
    this.margin = parseFloat(getComputedStyle(el).paddingTop);
    const height = parseFloat(getComputedStyle(el).paddingTop);
    const offset = `calc(${this.margin}px - ${this.tweak}px)`;

    this.inkbar = this.host._inkBar?.['_elementRef']?.nativeElement;

    this.inkbar.style.top = offset;
    this.offsetSet = true;
  }

  /* find the offset of the relevant selected tab by its index */
  getTabOffset(selectedTab) {
    setTimeout(() => {
      const activeTab = this.activeTab();

      if (activeTab) {
        const offset = activeTab.elementRef.nativeElement.offsetTop;
        const height = activeTab.elementRef.nativeElement.clientHeight;
        // this.setInkbar(offset, height);
      }
    }, 100);
  }

  /* apply transform styles and height calculations to inkbar */
  setInkbar(offset, height) {
    this.inkbar.style.transform = `translateY(${offset}px)`;
    this.inkbar.style.height = `calc(${height}px - (${this.margin}px * 2) + (${this.tweak}px * 2))`;
  }
}
